import biaoduan from './biaoduan'
import kproom from './kproom'

export default {
    path: 'fangan',
    component: () => import(/*webpackChunkName: 'bidding-fangn'*/ '@layout/empty'),
    children: [
        biaoduan,
        kproom
    ]
}